import { Link } from "react-router-dom";

export default function TermsOfUse() {
  return (
    <div className="font-['Lato'] bg-background-50 text-foreground-900 min-h-screen">
      {/* Header */}
      <header className="bg-foreground-950 text-white py-4 px-6 md:px-12">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <Link
            to="/"
            className="font-['Playfair_Display'] text-lg font-semibold text-white hover:text-accent-300 transition-colors"
          >
            JOINT GENESIS
          </Link>
          <Link
            to="/"
            className="text-white/60 text-sm hover:text-white transition-colors flex items-center gap-1"
          >
            <i className="ri-arrow-left-line" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <p className="font-['Playfair_Display'] text-accent-600 text-sm tracking-[0.25em] uppercase mb-4">
          Legal Information
        </p>
        <h1 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-10">
          Terms of Use
        </h1>
        <div className="w-16 h-px bg-accent-400 mb-12" />

        <div className="space-y-8 text-foreground-700 text-base leading-relaxed">
          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              1. Acceptance of Terms
            </h2>
            <p>
              By accessing and using this website, you acknowledge that you have read, understood, and agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use this website or any of its services.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              2. Educational Purpose
            </h2>
            <p>
              The content provided on this website, including articles, reports, and editorial materials, is for informational and educational purposes only. It is not intended to be a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified healthcare provider with any questions you may have regarding a medical condition.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              3. Product Disclaimer
            </h2>
            <p>
              Any references to products, supplements, or services on this website do not constitute an endorsement or guarantee of results. Individual experiences may vary. Statements regarding dietary supplements have not been evaluated by the Food and Drug Administration and are not intended to diagnose, treat, cure, or prevent any disease or health condition.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              4. Affiliate Disclosure
            </h2>
            <p>
              This website may contain affiliate links. If you click on an affiliate link and make a purchase, we may receive a commission at no additional cost to you. This helps support our editorial work and allows us to continue providing free educational content. We only recommend products and services that we believe provide value to our readers.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              5. Intellectual Property
            </h2>
            <p>
              All content on this website, including text, graphics, logos, images, and downloadable materials, is the property of Joint Genesis Editorial or its content suppliers and is protected by international copyright laws. Unauthorized use, reproduction, or distribution of any material without prior written consent is strictly prohibited.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              6. Limitation of Liability
            </h2>
            <p>
              To the fullest extent permitted by law, Joint Genesis Editorial and its affiliates shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising out of your access to or use of this website or its content. This includes, without limitation, any errors or omissions in any content, or any loss or damage of any kind incurred as a result of the use of any content posted, transmitted, or otherwise made available via the website.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              7. User Conduct
            </h2>
            <p>
              You agree not to use this website for any unlawful purpose or in any way that could damage, disable, overburden, or impair the website or interfere with any other party's use and enjoyment of the website. You agree not to attempt to gain unauthorized access to any portion of the website or any systems or networks connected to the website.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              8. Changes to Terms
            </h2>
            <p>
              We reserve the right to modify these Terms of Use at any time without prior notice. Your continued use of the website following any changes constitutes your acceptance of the new terms. We encourage you to review these terms periodically.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              9. Governing Law
            </h2>
            <p>
              These Terms of Use shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions. Any legal action or proceeding arising under these terms shall be brought exclusively in the federal or state courts located within the United States.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-semibold text-foreground-900 mb-3">
              10. Contact Information
            </h2>
            <p>
              If you have any questions about these Terms of Use, please contact us through the appropriate channels provided on our website.
            </p>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-background-200">
          <p className="text-foreground-400 text-sm text-center">
            Last updated: July 2026
          </p>
        </div>
      </main>

      {/* Simple Footer */}
      <footer className="bg-foreground-950 text-white/50 py-8 px-6">
        <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm">
          <span className="font-['Playfair_Display'] text-white font-semibold">
            JOINT GENESIS
          </span>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white transition-colors">
              Terms of Use
            </Link>
          </div>
          <span>&copy; 2026 All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
}